import { useQuery } from 'convex/react';
import { api } from 'convex/_generated/api';
import { useSettingsStore } from '@shared/store/useSettingsStore';
import { ComponentType } from 'react';

export interface SettingsProps {
  isLoading: boolean;
  saveMessage: string | null;
  isSaving: boolean;
  onChangePassword?: () => void;
  onSignOut?: () => void | Promise<void>;
}

interface SettingsContainerProps {
  View: ComponentType<SettingsProps>;
  onChangePassword?: () => void;
  onSignOut?: () => void | Promise<void>;
}

export function SettingsContainer({ View, onChangePassword, onSignOut }: SettingsContainerProps) {
  const preferences = useQuery(api.userPreferences.queries.getUserPreferences, {});
  const isSaving = useSettingsStore((state) => state.isSaving);
  const saveMessage = useSettingsStore((state) => state.saveMessage);

  const isLoading = preferences === undefined;

  return (
    <View
      isLoading={isLoading}
      isSaving={isSaving}
      saveMessage={saveMessage}
      onChangePassword={onChangePassword}
      onSignOut={onSignOut}
    />
  );
}
